import * as React from 'react';
import * as classNames from "classnames";
import './TrialNotesPage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactSelectClass from "react-select";
import ReactTable, { Column, RowInfo } from 'react-table';
import * as ReactTooltip from 'react-tooltip';
import Alert from 'react-s-alert';
import { DefaultLayout, RestrictedLayout, UnrestrictedLayout, SubMenu } from "../../../components/layouts/index";
import * as TrialActions from '../../../actions/trial';
import * as ToggleActions from '../../../actions/pages/togglePage';
import * as ToggleHelper from "../../../helpers/toggleHelper";
import { TogglePageItem } from '../../../reducers/pages/togglePage';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { convertToShortDateString, convertToDateTimeString, convertToApproximateDateString } from "../../../helpers/date";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { ILinkProps } from "../../../components/routing/Link";
import { INavItem } from "../../../components/layouts/NavMenu/NavMenu";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import { setModalTitle } from "../../../helpers/modalHelper";
import { Modal, NotificationAlert } from "../../../components/common/index";
import * as AuthenticationHelper from '../../../helpers/authentication';
import * as AuthorisationDefinitions from '../../../constants/authorisationDefinitions';
import { ModalSize } from '../../../enumerations/ModalSize';
import { Form, actions, Control } from 'react-redux-form';
import { TextAreaFormInput } from '../../../components/form';
import { TrialSubMenu } from '../../../helpers/subMenuHelper';
import { TrialLayout } from '../../index';
interface ITrialNotesPageParams {
  trialId: number;
}
interface ITrialNotesPageProps {
  location: Location;
  trialId: number;
  match: match<ITrialNotesPageParams>;
  history: History;

  // From state
  trial: Dtos.Trial;
  trialRoles: Dtos.RoleType[];
  loadingTrial: boolean;
  loadTrialSuccess: boolean;
  loadTrialFailure: boolean;
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
  toggleItems: TogglePageItem[];
}
interface ITrialNotesPageActions {
  clearTrial: TrialActions.ITrialClearActionCreator;
  loadTrial: TrialActions.ITrialLoadByIdActionCreator;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
  toggleExpand: ToggleActions.IToggleExpandedStateActionCreator;
}
type TrialNotesPageProps = ITrialNotesPageProps & ITrialNotesPageActions;
const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex";
const tableStyleClass: React.CSSProperties = {
  textAlign: "left",
  fontWeight: "bold",
  color: "white",
  cursor: "pointer"
};
class TrialNotesPage extends React.PureComponent<TrialNotesPageProps, any> {
  constructor(props: TrialNotesPageProps) {
    super(props);
    this.clearTrial = this.clearTrial.bind(this);
  }
  componentDidMount() {
    const {
      loadTrial,
      navigate,
      navigateReplace,
      trialId
    } = this.props;
    loadTrial(trialId, false, false, false, true, false);
  }
  componentWillReceiveProps(nextProps: TrialNotesPageProps) {}
  componentDidUpdate(prevProps: TrialNotesPageProps, prevState) {
    const {
      navigateReplace,
      loadTrial
    } = this.props;
  }
  componentWillUpdate(nextProps: TrialNotesPageProps) {}
  componentWillUnmount() {
    this.clearTrial();
  }
  clearTrial() {
    this.props.clearTrial();
  }
  showTrial(): boolean {
    const {
      loadingTrial,
      loadTrialSuccess
    } = this.props;
    if (!loadingTrial && loadTrialSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingTrial
    } = this.props;
    return <TrialLayout loading={loadingTrial} permission={Dtos.Permission.TrialNoteView} data-sentry-element="TrialLayout" data-sentry-component="TrialNotesPage" data-sentry-source-file="TrialNotesPage.tsx">{this.renderContent()}</TrialLayout>;
  }
  renderContent() {
    const {
      trial,
      loadingTrial,
      loadTrialSuccess,
      loadTrialFailure,
      clearTrial,
      permissions,
      trialId
    } = this.props;
    return <div>
            <div className="row">
                <div className={"col-9 mb-2"}>
                    <h2>Trial Notes</h2>
                </div>
                <div className="col-3" style={{
          textAlign: 'right'
        }}>
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialNoteCreate, trialId, null) && trial && trial.id > 0 && <Link className={"btn btn-primary"} url={"/trials/" + trial.id + '/notes/create'}>Create</Link>}
                </div>
            </div>
            {!this.showTrial() ? "Loading Trial Notes" : null}
            {this.showTrial() ? <div className="mt-2">
                        {this.renderTable()}
                    </div> : null}
        </div>;
  }
  toggle(noteTypeNotes: Dtos.NoteTypeNotes) {}
  renderTable() {
    const {
      trial,
      toggleItems,
      toggleExpand
    } = this.props;
    if (!trial || !trial.notes || trial.notes.length == 0) {
      return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no notes to view.</span>
            </div>;
    }
    const showPagination = false; //personnelRoleSummaries.length > DEFAULT_PAGE_SIZE;

    return <div>
            {trial && trial.notes && trial.notes.map((item, index) => {
        const key = "trial-notes-page-" + item.noteTypeId;
        const expanded = ToggleHelper.isToggleExpanded(toggleItems, key);
        return <div key={"note-type" + index}>
                        <div className={tableHeaderClass} style={tableStyleClass} onClick={() => toggleExpand(key)}>
                            <div>
                                <FontAwesomeIcon icon={!expanded ? FontAwesomeIcons.Solid.ANGLE_DOWN : FontAwesomeIcons.Solid.ANGLE_UP} fixedWidth transform="grow-16" className="mr-3" />
                            </div>
                            <span>{item.noteType.value}</span>
                        </div>
                        {expanded && <ReactTable data={item.notes} pageSizeOptions={PAGE_SIZE_OPTIONS} defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : item.notes.length} pageSize={showPagination ? undefined : item.notes.length} showPagination={showPagination} className="-striped -highlight -clickable mb-3" noDataText="There are currently no notes for this type" resizable={false} getTdProps={(state, rowInfo: RowInfo, column, instance) => {
            return {
              onClick: (e, handleOriginal) => {
                const url: string = "/trials/" + trial.id + '/notes/' + rowInfo.original.id;
                this.props.navigate(url);
                if (handleOriginal) {
                  handleOriginal();
                }
              },
              style: {
                color: rowInfo && rowInfo.original && rowInfo.original.active ? '#212529' : '#9e9e9e'
              }
            };
          }} columns={[{
            id: "id",
            Header: ' ',
            accessor: "id",
            className: "d-flex align-items-center justify-content-center",
            maxWidth: 50,
            Cell: props => <FontAwesomeIcon icon={FontAwesomeIcons.Light.NOTE} fixedWidth />
          }, {
            id: "title",
            Header: "Title",
            accessor: "title",
            className: "d-flex align-items-left justify-content-left",
            headerClassName: "text-left"
          }, {
            id: "comments",
            Header: "Comments",
            accessor: "comments",
            className: "d-flex align-items-left justify-content-left",
            headerClassName: "text-left"
          }, {
            id: "dateEntered",
            Header: "Date Entered",
            accessor: "dateEntered",
            className: "d-flex align-items-center justify-content-center",
            maxWidth: 180,
            Cell: props => <div><span data-tip={convertToApproximateDateString(props.value)}>{convertToShortDateString(props.value)}</span><ReactTooltip /></div>
          }]} />}
                    </div>;
      })}
        </div>;
  }
}
const mapStateToProps = (state: ITmdState, ownProps: TrialNotesPageProps): ITrialNotesPageProps => {
  let trial: Dtos.Trial | undefined = !(state.trials.formData instanceof Array) ? state.trials.formData : undefined;
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    match: ownProps.match,
    trialId: ownProps.match ? ownProps.match.params.trialId : undefined!,
    history: ownProps.history,
    location: state.routing.location,
    trial: trial!,
    trialRoles: state.trials.formRoles,
    loadingTrial: state.trials.loadState && state.trials.loadState.status == RequestState.Pending,
    loadTrialSuccess: state.trials.loadState && state.trials.loadState.status == RequestState.Success,
    loadTrialFailure: state.trials.loadState && state.trials.loadState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    toggleItems: state.togglePage.items
  };
};
const mapDispatchToProps = (dispatch): ITrialNotesPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadTrial: bindActionCreators(TrialActions.LoadTrialById, dispatch),
    clearTrial: bindActionCreators(TrialActions.Clear, dispatch),
    toggleExpand: bindActionCreators(ToggleActions.ToggleExpanded, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TrialNotesPage);